<template>
  <div>
    <ts-loading-banner :loading="loading">
      <div class="row">
        <div class="col-md-12">
          <label class="ts-uppercase ts-font-semibold ts-bg-blue-600 ts-text-white ts-px-1 ts-pt-1 ts-rounded-sm">{{
            $t('user.roleName')
          }}</label>
          <div id="role-group">
            <a-radio-group v-model="model.roles">
              <a-radio 
                v-for="(role, index) in roles"
                :key="index"
                :style="radioStyle"
                :value="role.id"
              >
              {{ role.name }}
              </a-radio>
            </a-radio-group>
            <!-- <ul class="ts-reset ts-px-4 ts-py-2 ts-h-full">
              <li v-for="role in roles" :key="role.id"
                class="ts-flex ts-items-center"
              >
                <ts-checkbox v-model="model.roles" :value="role.id" class="ts-capitalize">{{
                  role.name
                }}</ts-checkbox>


                <ts-radio  class="ts-capitalize">
                  {{ role.name }}
                </ts-radio>
              </li>
            </ul> -->
          </div>
        </div>
      </div>
    </ts-loading-banner>
  </div>
</template>

<script>
export default {
  name: 'roleComponent',
  props: ['value'],
  data() {
    return {
      loading: false,
      roles: [],
      model: {},
      radioStyle: {
        display: 'block',
        height: '25px',
        lineHeight: '30px',
      },
    }
  },
  created() {
    this.model = this.value
    this.fetchRole()
  },
  methods: {
    fetchRole() {
      this.loading = true
      this.$store
        .dispatch('security/user/getRole')
        .then(response => {
          this.roles = response.data
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="css" scoped>
#role-group {
  min-height: 150px;
  max-height: 160px;
  overflow-y: scroll;
}
</style>
